// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---customer-century-21-immoeffertz-page-template-files-page-tsx": () => import("./../../../customer/Century21Immoeffertz/page-template/files-page.tsx" /* webpackChunkName: "component---customer-century-21-immoeffertz-page-template-files-page-tsx" */),
  "component---customer-century-21-immoeffertz-page-template-presentation-page-tsx": () => import("./../../../customer/Century21Immoeffertz/page-template/presentation-page.tsx" /* webpackChunkName: "component---customer-century-21-immoeffertz-page-template-presentation-page-tsx" */)
}

